module.exports = __webpack_public_path__ + "static/media/team.cc1d1907.svg";